import React from 'react';
import './ProgressBar.scss';

const ProgressBar = props => {
  return (
    <div className={'lmapp-progress'}>
      <div className={'lmapp-progress-bar'} style={{ width: props.percentageDone + '%' }} />
    </div>
  );
};

export default ProgressBar;
